import React, { useEffect, useRef, useState } from "react";
import { Form, Row, Col, Spinner } from "react-bootstrap";
import HtmlToString from "../../../../components/Formatters/HtmlToString";
import HtmlEditor from "../../../../components/UI/HtmlEditorInput/HtmlEditor";
import DateTimeInputFormik from "../../../../components/UI/DateTimeInput/DateTimeInputFormik";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const FormOcorrencia = ({
  formik,
  tipoAutoInfracao,
  sqItemOcorrencia,
  dadosOs,
  dadosAIEspecial,
  dadosAuto,
  propsOcorrencia,
}) => {
  const [dadosOcorrencia, setDadosOcorrencia] = useState([]);
  const { request, data, isLoading } = useApiClient();
  const sqAutoAberto = useRef(0);
  const txOcorrenciasAux = useRef(formik.values.txOcorrencias);

  useEffect(() => {
    if (tipoAutoInfracao || sqItemOcorrencia > 0) {
      const params = {
        sqAcaoFiscal: dadosOs.acaoFiscal,
        tipoAutoInfracao:
          tipoAutoInfracao !== undefined || tipoAutoInfracao !== null
            ? tipoAutoInfracao
            : dadosAIEspecial[0]?.tipoAutoAberto,
        sqAutoInfracao: dadosAIEspecial[0]?.sequencialAutoAberto > 0 ? dadosAIEspecial[0]?.sequencialAutoAberto : 0,
        sqItemOcorrencia,
      };

      request(apiRoutes.fiscalizacao.autoinfracao.consultaOcorrenciaOs, params);
    }
  }, [request, tipoAutoInfracao, sqItemOcorrencia, dadosOs.acaoFiscal, dadosAIEspecial]);

  const { setValues } = formik;

  useEffect(() => {
    if (data) {
      setDadosOcorrencia(data.result[0]);
    }
  }, [data, setDadosOcorrencia]);

  useEffect(() => {
    if (dadosAIEspecial[0]?.sequencialAutoAberto > 0) {
      sqAutoAberto.current = dadosAIEspecial[0]?.sequencialAutoAberto;
    }
  }, [dadosAIEspecial]);

  useEffect(() => {
    const txTipoOcorrencia = dadosOcorrencia.txTipoOcorrencia ? dadosOcorrencia.txTipoOcorrencia : "";
    const descricaoOcorrencia = propsOcorrencia.descricaoOcorrencia
      ? propsOcorrencia.descricaoOcorrencia
      : dadosOcorrencia.descricaoOcorrencia;
    const dataVencimento = dadosOcorrencia.dataVencimento ? dadosOcorrencia.dataVencimento : new Date();
    const dataPeriodoInicial = dadosOcorrencia.dataPeriodoInicial ? dadosOcorrencia.dataPeriodoInicial : new Date();
    const dataPeriodoFinal = dadosOcorrencia.dataPeriodoFinal ? dadosOcorrencia.dataPeriodoFinal : new Date();
    const sequencialAutoInfracao = sqAutoAberto.current !== undefined ? sqAutoAberto.current : 0;
    const sequencialTipoOcorrencia = dadosOcorrencia.sequencialTipoOcorrencia
      ? dadosOcorrencia.sequencialTipoOcorrencia
      : 0;

    const txInfrigComplemento = dadosOcorrencia?.txInfringenciaComplemento
      ? dadosOcorrencia?.txInfringenciaComplemento
      : "";
    const txInfringenciaComplemento = propsOcorrencia.txInfringenciaComplemento
      ? propsOcorrencia?.txInfringenciaComplemento
      : txInfrigComplemento;

    const txPenalComplemento = dadosOcorrencia?.txPenalidadeComplemento ? dadosOcorrencia?.txPenalidadeComplemento : "";

    const txPenalidadeComplemento = propsOcorrencia.txPenalidadeComplemento
      ? propsOcorrencia?.txPenalidadeComplemento
      : txPenalComplemento;

    const txInfrigenciaAux = dadosOcorrencia.txInfringencia
      ? `<b>Infringência:</b> ${dadosOcorrencia.txInfringencia}  ${txInfringenciaComplemento}`
      : "";
    const txPenalidadeAux = dadosOcorrencia.txPenalidade
      ? `<b>Penalidade:</b> ${dadosOcorrencia.txPenalidade}  ${txPenalidadeComplemento}`
      : "";

    const dsOcorrencia = dadosOcorrencia.descricaoOcorrencia
      ? `<b>Ocorrência:</b> ${dadosOcorrencia.descricaoOcorrencia} `
      : "";

    let txOcorrenciasFinal = "";

    if (sqItemOcorrencia === 0) {
      txOcorrenciasFinal = `${txOcorrenciasAux.current}  <br /> <br /> ${dsOcorrencia} <br />  ${txInfrigenciaAux} <br /> ${txPenalidadeAux}`;
    } else {
      txOcorrenciasFinal =
        dadosAuto?.txOcorrencias !== undefined || dadosAuto?.sequencialAutoAberto > 0
          ? dadosAuto?.txOcorrencias
          : dadosAIEspecial[0]?.txOcorrencias;
    }

    setValues((curr) => ({
      ...curr,
      sequencialTipoOcorrencia,
      txTipoOcorrencia,
      descricaoOcorrencia,
      dataVencimento,
      dataPeriodoInicial,
      dataPeriodoFinal,
      txInfringenciaComplemento,
      txPenalidadeComplemento,
      sequencialAutoInfracao,
      txOcorrencias: txOcorrenciasFinal,
    }));
  }, [setValues, dadosOcorrencia, dadosAIEspecial, sqItemOcorrencia, dadosAuto, propsOcorrencia]);

  if (isLoading) {
    return (
      <span>
        <Spinner animation="border" role="status" />
        Carregando...
      </span>
    );
  }

  if (dadosOcorrencia?.length === 0) {
    return (
      <div className="alert alert-danger" role="alert">
        Não existe ocorrência cadastrada para esse tipo de auto de infração.
      </div>
    );
  }

  return (
    <>
      <Row>
        <Col sm={12} md={3}>
          <b>Nº Tipo Ocorrência</b>
          <br />
          {formik.values.sequencialTipoOcorrencia}
        </Col>
        <Col sm={12} md={9}>
          <Form.Label>
            <b>Tipo de Ocorrência </b>
          </Form.Label>{" "}
          <br />
          <Form.Label>
            <HtmlToString html={dadosOcorrencia.txTipoOcorrencia} />
          </Form.Label>
        </Col>
      </Row>{" "}
      <br />
      <Row>
        <Col sm={12} md={3}>
          <Form.Label>
            <b>Infringência </b>
          </Form.Label>{" "}
          <br />
          <Form.Label>
            <HtmlToString html={dadosOcorrencia.txInfringencia} />
          </Form.Label>
        </Col>
        <Col sm={12} md={9}>
          <Form.Label>
            <b>Penalidade </b>
          </Form.Label>{" "}
          <br />
          <Form.Label>
            <HtmlToString html={dadosOcorrencia.txPenalidade} />
          </Form.Label>
        </Col>
      </Row>{" "}
      <br />
      <Row>
        <Form.Group as={Col} sm={12} md={12}>
          <br />
          <Form.Label>
            <strong>Descrição</strong>
          </Form.Label>
          <HtmlEditor formik={formik} field="descricaoOcorrencia" />
        </Form.Group>
      </Row>{" "}
      <br />
      <Row>
        <Col sm={12} md={2}>
          <Form.Label>
            <strong>Data Vencimento</strong>
          </Form.Label>
          <div className="form-inline">
            <DateTimeInputFormik formik={formik} field="dataVencimento" />
          </div>
        </Col>
        <Col sm={12} md={10}>
          <Form.Label>
            <strong>Período de Referência</strong>
          </Form.Label>
          <div className="form-inline">
            <DateTimeInputFormik formik={formik} field="dataPeriodoInicial" />
            <Form.Label className="mx-3"> a </Form.Label>
            <DateTimeInputFormik formik={formik} field="dataPeriodoFinal" />
          </div>
        </Col>
      </Row>{" "}
      <br />
      <Row>
        <Form.Group as={Col} sm={12} md={12}>
          <Form.Label>
            <strong>Complemento de Infringência</strong>
          </Form.Label>
          <HtmlEditor formik={formik} field="txInfringenciaComplemento" style={{ height: "150px" }} />
        </Form.Group>
      </Row>{" "}
      <br />
      <Row>
        <Form.Group as={Col} sm={12} md={12}>
          <Form.Label>
            <strong>Complemento de Penalidade</strong>
          </Form.Label>
          <HtmlEditor formik={formik} field="txPenalidadeComplemento" style={{ height: "150px" }} />
        </Form.Group>
      </Row>
    </>
  );
};
export default FormOcorrencia;
